import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import IconComponent from "../../components/icon/Icon";

export default function FindAdventureCTR({ mt = "mt-12" }) {
  const [selectedDestination, setSelectedDestination] = useState("");
  const [destinations, setDestinations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        const res = await fetch("https://bonvoytourism.com/bonvoytourismbackend/api/packages");
        // const res = await fetch("https://demo.bonvoytourism.com/bonvoytourismbackend/api/packages");
        // const res = await fetch("http://localhost:3000/bonvoytourismbackend/api/packages");
        const data = await res.json();

        if (data.destinations) {
          const uniqueDestinations = Array.from(
            new Set(data.destinations.map((d) => d.name))
          );
          setDestinations(uniqueDestinations);
        }
      } catch (error) {
        console.error("Error fetching tours:", error);
      }
    };

    fetchDestinations();
  }, []);

  const handleFindNow = () => {
    if (selectedDestination) {
      navigate(`/tour?destination=${selectedDestination}`);
    } else {
      alert("Please select a tour!");
    }
  };

  return (
    <div
      className={`${mt} relative bg-cover bg-center bg-no-repeat px-6 sm:px-10 md:px-14 lg:px-20 py-6 sm:py-10 md:py-14`}
      style={{ backgroundImage: "url('/images/home/finder.jpg')" }}
    >
      <div className="absolute inset-0 bg-black/50 z-0"></div>
      <div className="relative z-10">

        <h3 className="text-[24px] md:text-[30px] font-semibold mb-6 text-white">
          Find your adventure with us
        </h3>
        <p className="mt-2 text-white text-sm md:text-base mb-4 max-w-[800px]">
          Choose your preferred tour and explore amazing travel packages curated just for you. From heart-pounding red dune safaris to peaceful cultural day trips across all seven emirates — your perfect Dubai experience is waiting.
        </p>
        <div className="grid grid-cols-1 max-w-[400px] gap-4 mb-4 md:mb-8 text-[13px] md:text-[16px]">
          <div>
            <h3 className="text-[13px] font-medium mb-2 text-white">Tours</h3>
            <div className="relative w-full">
              <select
                value={selectedDestination}
                onChange={(e) => setSelectedDestination(e.target.value)}
                className="bg-white appearance-none rounded-[4px] py-2 px-3 pr-10 text-[#969595] w-full focus:outline-none focus:border-[#85009D]"
              >
                <option value="">Select Tour</option>
                {destinations.map((dest, index) => (
                  <option key={index} value={dest}>
                    {dest}
                  </option>
                ))}
              </select>

              <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2">
                <IconComponent name="drop-down" color="#808080" size={16} />
              </div>
            </div>
          </div>

          <button
            onClick={handleFindNow}
            className="bg-[#ff9219] text-white mt-[8px] md:mt-0 py-2 px-3 rounded-[4px] font-medium hover:bg-slate-400 transition-all duration-300 ease-in-out"
          >
            FIND NOW
          </button>
        </div>
      </div>
    </div>
  );
}
